export default "flat varying vec4 vGPUColor;";